import { IconProps, colour, Colour } from '../Icon/types'

export enum Size {
  SMALL = 'SMALL',
  REGULAR = 'REGULAR',
  LARGE = 'LARGE'
}

export interface IconPropsExtended extends IconProps {
  haloColor?: Colour | colour
  maintainColorWhenSelected?: boolean
}

export interface GrowingIconProps {
  icon: IconPropsExtended
  selected?: boolean
  size?: Size
  /** This will be removed once any components passing it are amended to use the extended icon props above */
  haloColor?: colour
  hovered?: boolean
  dataBdd?: string
}
